// extracted by mini-css-extract-plugin
module.exports = {"userAvatar":"styles_userAvatar__QQKZm","fullWidthDate":"styles_fullWidthDate__y4I4b"};